module.exports = __webpack_public_path__ + "static/media/116-curacao.32e5c021.svg";